module.exports = __webpack_public_path__ + "img/type--3-spans--single-lang--es.ae3d03d3.jpg";